import * as React from 'react';
import { IWizardContext } from './wizard-context.types';

export const WizardContext = React.createContext<IWizardContext>({} as IWizardContext);
